<template>
    <div class="medical-records health-product">
        <div class="row">
            <div class="col-12 mb-4 ">
                <div class="bg-white border-radius-5 ">
                    <div class="card border-0 p-0 ">
                        <div class="card-body p-0 ">
                            <div class="row align-items-center ">
                                <div class="col-md-6">
                                    <div class="card border-0">
                                        <div class="card-body p-0">
                                            <figure
                                                class=" text-center d-flex justify-content-center align-items-center p-4 bg-white mb-0">
                                                <img src="../../../../static/website/images/fitness-band.png" alt="">
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 ">
                                    <div class="card border-0">
                                        <div class="health-product-details p-4 card-body ">
                                            <div class="breadcrumbs">
                                                <ul class=" d-flex">
                                                    <li><a href="#" class="pl-0">Home</a><i
                                                            class="icon icon-chevron-down"></i></li>
                                                    <li><a href="#">Health Tracker</a><i class="icon icon-chevron-down"></i>
                                                    </li>
                                                    <li><span>669 Smart sports bracelet</span></li>
                                                </ul>
                                            </div>
                                            <h2>669 smart sports bracelet</h2>
                                            <h3>US$ 179.95</h3>
                                            <a href="#" class="review">Be the first to review this product</a>
                                            <p>The Aluminum alloy shell smart band is available in three different colors.
                                                Our health band
                                                offers a Resolution of 240*240 display and an international standard rating
                                                of IP68. </p>
                                            <div class="radiobuttons d-flex mb-3">
                                                <div class="rdio rdio-primary radio-inline"> <input name="radio" value="1"
                                                        id="radio1" type="radio" checked>
                                                    <label for="radio1" class="color-1"></label>
                                                </div>
                                                <div class="rdio rdio-primary radio-inline">
                                                    <input name="radio" value="2" id="radio2" type="radio">
                                                    <label for="radio2" class="color-2"></label>
                                                </div>
                                                <div class="rdio rdio-primary radio-inline">
                                                    <input name="radio" value="3" id="radio3" type="radio">
                                                    <label for="radio3" class="color-3"></label>
                                                </div>
                                            </div>
                                            <div class="Special-Features">
                                                <h4>Special Features are</h4>
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <ul class="mb-0">
                                                        <li><i class="icon icon-chevron-down"></i>Dynamic Heart Rate</li>
                                                        <li><i class="icon icon-chevron-down"></i>Blood Oxygen monitor</li>
                                                        <li><i class="icon icon-chevron-down"></i>Sports Mode</li>
                                                        <li><i class="icon icon-chevron-down"></i>Multi Purpose Reminders
                                                        </li>
                                                    </ul>
                                                    <router-link to="health-cart" class="btn btn-blue Buy-Now">Buy Now</router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="row align-items-center justify-content-center">
                                <div class="col-md-8 col-12">
                                    <div class="row no-gutters align-items-center mt-4 voice-assistant">
                                        <div class="col-md-6">
                                            <div class="card border-0">
                                                <div class="card-body p-0">
                                                    <figure
                                                        class=" text-center d-flex justify-content-end align-items-center p-4 bg-white mb-0">
                                                        <img src="../../../../static/website/images/voice-assistant.png" alt="">
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 pl-5">
                                            <div class="card border-0">
                                                <div class="card-body p-0">
                                                    <h2 class="mb-5">Run your day with a voice assistant</h2>
                                                    <p>Use Google Assistant or Amazon Alexa Built-in to get quick news and
                                                        weather, set
                                                        bedtime reminders & alarms and more—just by speaking to your Sense
                                                        or Gini Fitness Band
                                                    </p>
                                                    <a href="#" class="learn-more">Learn More</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row align-items-center justify-content-center fitness-band">
                                <div class="col-md-9 p-md-5">
                                    <div class="row no-gutters align-items-center mt-4">
                                        <div class="col-md-6">
                                            <div class="card border-0">
                                                <div class="card-body p-0">
                                                    <h2>Put motivation on your wrist with new Ginis Fitness band/Bracelet
                                                    </h2>
                                                    <p>Say hello to the all-day watch with built-in GPS, Active Zone Minutes
                                                        and smart
                                                        experiences to keep you moving.</p>
                                                    <a href="#" class="learn-more">Learn More</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-12">
                                            <div class="card border-0 bg-transparent">
                                                <div class="card-body p-0 bg-transparent">
                                                    <figure
                                                        class=" text-center d-flex justify-content-end align-items-center p-4 bg-transparent mb-0">
                                                        <img src="../../../../static/website/images/band.png" alt="">
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="row no-gutters parameters-section justify-content-center mt-5 mb-3 basic-parameters">
                                <div class="col-md-7 text-center mb-4">
                                    <h2>Basic Parameters</h2>
                                    <p>Ginis Smartwatch not only satiates your requirements as far as technical aspects are
                                        concerned
                                        but is also endowed with real-time tracking features that go on to become prudent in
                                        your
                                        journey towards healthier living.</p>
                                </div>
                                <div class="col-md-10 col-12">
                                    <div class="row no-gutters align-items-center">
                                        <div class="col-md-4 col-12 parameters-left">
                                            <ul class="mb-0">
                                                <li class="d-flex justify-content-end mb-5 align-items-center">
                                                    <p>Ultra-low power consumption Realtek 8762C. Normal use 8-10 days.
                                                        Standby time 60 days.
                                                    </p>
                                                    <figure class="mb-0">
                                                        <img src="../../../../static/website/images/icon-set/lighting.svg" alt="">
                                                    </figure>
                                                </li>
                                                <li class="d-flex justify-content-end mb-5 align-items-center">
                                                    <p>1.28 Full circle full touch. HD resolution 240*240.</p>
                                                    <figure class="mb-0">
                                                        <img src="../../../../static/website/images/icon-set/smartphone.svg" alt="">
                                                    </figure>
                                                </li>
                                                <li class="d-flex justify-content-end  align-items-center">
                                                    <p>APP interface language 15 languages</p>
                                                    <figure class="  mb-0">
                                                        <img src="../../../../static/website/images/icon-set/languages.svg" alt="">
                                                    </figure>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-4 col-12">
                                            <figure
                                                class=" text-center d-flex justify-content-center align-items-center bg-transparent mb-0">
                                                <img src="../../../../static/website/images/parameters.png" alt="">
                                            </figure>
                                        </div>
                                        <div class="col-md-4 col-12 parameters-right">
                                            <ul class="mb-0">
                                                <li class="d-flex justify-content-end mb-5 align-items-center">
                                                    <figure class="mb-0">
                                                        <img src="../../../../static/website/images/icon-set/heart-rate.svg" alt="">
                                                    </figure>
                                                    <p>Real-time heart rate measurement</p>

                                                </li>
                                                <li class="d-flex justify-content-end mb-5 align-items-center">
                                                    <figure class="mb-0">
                                                        <img src="../../../../static/website/images/icon-set/social-software.svg" alt="">
                                                    </figure>
                                                    <p>Social software supports more than 20 kinds of information push</p>

                                                </li>
                                                <li class="d-flex justify-content-end align-items-center">
                                                    <figure class="  mb-0">
                                                        <img src="../../../../static/website/images/icon-set/smartphone.svg" alt="">
                                                    </figure>
                                                    <p>Up to nearly 50 dials (will be added in the future). </p>

                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="row parameters-section justify-content-center mt-5 py-5 px-3 basic-skills">
                                <div class="col-md-7  col-12 text-center mb-4">
                                    <h2>Basic Skills</h2>
                                    <p>Beyond fitness and health, the Gini Watch Revolve also focuses on your daily
                                        lifestyle drivers.
                                        There’s a host of features for you can look forward to and round off your every need
                                        and
                                        accessorise in style.</p>
                                </div>
                                <div class="col-md-12 text-center">
                                    <div class="row no-gutters mb-5">
                                        <div class="col-md-12  col-12 text-center">
                                            <div class="row no-gutters ">
                                                <div class="col">
                                                    <figure>
                                                        <img src="../../../../static/website/images/icon-set/heart.svg" alt="">
                                                    </figure>
                                                    <h3>Heart</h3>
                                                </div>
                                                <div class="col">
                                                    <figure>
                                                        <img src="../../../../static/website/images/icon-set/thermometer.svg" alt="">
                                                    </figure>
                                                    <h3>Blood Pressure</h3>
                                                </div>
                                                <div class="col">
                                                    <figure>
                                                        <img src="../../../../static/website/images/icon-set/fitness.svg" alt="">
                                                    </figure>
                                                    <h3>Exercise Data Collection</h3>
                                                </div>
                                                <div class="col">
                                                    <figure>
                                                        <img src="../../../../static/website/images/icon-set/phone-call.svg" alt="">
                                                    </figure>
                                                    <h3>Custom Dial</h3>
                                                </div>
                                                <div class="col">
                                                    <figure>
                                                        <img src="../../../../static/website/images/icon-set/moon.svg" alt="">
                                                    </figure>
                                                    <h3>Sleep Monitoring</h3>
                                                </div>
                                                <div class="col">
                                                    <figure>
                                                        <img src="../../../../static/website/images/icon-set/alarm-clock.svg" alt="">
                                                    </figure>
                                                    <h3>Alarm Clock</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row  mb-5 justify-content-center">
                                        <div class="col-md-10 col-12 text-center">
                                            <div class="row no-gutters ">
                                                <div class="col">
                                                    <figure>
                                                        <img src="../../../../static/website/images/icon-set/sedentary.svg" alt="">
                                                    </figure>
                                                    <h3>Sedentary Reminder</h3>
                                                </div>
                                                <div class="col">
                                                    <figure>
                                                        <img src="../../../../static/website/images/icon-set/synchronize.svg" alt="">
                                                    </figure>
                                                    <h3>Synchronized Exercise Data</h3>
                                                </div>
                                                <div class="col">
                                                    <figure>
                                                        <img src="../../../../static/website/images/icon-set/smartphone-1.svg" alt="">
                                                    </figure>
                                                    <h3>Paired with client APP</h3>
                                                </div>
                                                <div class="col">
                                                    <figure>
                                                        <img src="../../../../static/website/images/icon-set/settings.svg" alt="">
                                                    </figure>
                                                    <h3>Personalized Settings</h3>
                                                </div>
                                                <div class="col">
                                                    <figure>
                                                        <img src="../../../../static/website/images/icon-set/reminder.svg" alt="">
                                                    </figure>
                                                    <h3>Incoming call reminder</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row no-gutters mb-3 justify-content-center ">
                                        <div class="col-md-8 col-12 text-center">
                                            <div class="row no-gutters">
                                                <div class="col">
                                                    <figure>
                                                        <img src="../../../../static/website/images/icon-set/image-gallery.svg" alt="">
                                                    </figure>
                                                    <h3>shake it Take pictures</h3>
                                                </div>
                                                <div class="col">
                                                    <figure>
                                                        <img src="../../../../static/website/images/icon-set/location.svg" alt="">
                                                    </figure>
                                                    <h3>find mobile phones</h3>
                                                </div>
                                                <div class="col">
                                                    <figure>
                                                        <img src="../../../../static/website/images/icon-set/push.svg" alt="">
                                                    </figure>
                                                    <h3>push information</h3>
                                                </div>
                                                <div class="col">
                                                    <figure>
                                                        <img src="../../../../static/website/images/icon-set/smartwatch.svg" alt="">
                                                    </figure>
                                                    <h3>raise the wrist to brighten the screen</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-md-12 col-12 text-center">
                                    <a href="#" class="many-more">many more....</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
	export default {
        name: 'health-single-product',

    }
</script>


// WEBPACK FOOTER //
// src/components/website/health_tracker/health-single-product.vue